<script>
export default {
  name: 'GridOptions',
  props: {
    gridState: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fullscreen: false,
      form: {
        label_classification: true,
        label_driver: true,
        label_hull: false,
        classification_type: 'category',
      },
    }
  },
  computed: {
    classificationOptions() {
      return [
        {
          text: this.$t('global.object.fleetCategory'),
          value: 'category',
        },
        {
          text: this.$t('global.object.fleetType'),
          value: 'type',
        },
        {
          text: this.$t('global.object.manufacture'),
          value: 'manufacture',
        },
      ]
    },
  },
  mounted() {
    window.addEventListener('popstate', () => {
      if (document.body.classList.contains('mc-trackvideo-fullscreen')) {
        document.body.classList.remove('mc-trackvideo-fullscreen')
      }
    })
    const setDisplay = JSON.parse(localStorage.getItem('trackvideo-set-display'))
    if (setDisplay) {
      this.form = setDisplay
    } else {
      localStorage.setItem('trackvideo-set-display', JSON.stringify(this.form))
    }
    this.$store.commit('video/setFleetListDisplay', this.form)
  },
  methods: {
    async clickFullScreen() {
      this.fullscreen = !this.fullscreen
      await this.$nextTick()

      document.body.classList.toggle('mc-trackvideo-fullscreen')
    },
    setting() {
      localStorage.setItem('trackvideo-set-display', JSON.stringify(this.form))
      this.$store.commit(
        'video/setFleetListDisplay',
        JSON.parse(localStorage.getItem('trackvideo-set-display'))
      )
    },
    handleClickLabel(value) {
      this.form.classification_type = value
      this.setting()
    },
  },
}
</script>

<template>
  <div class="mc-trackvideo-content__view">
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridOne' }"
      @click="$emit('clickGridNumber', 'gridOne', 1)"
    >
      <i class="mc-fa icon-fill_grid-1"></i>
    </span>
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridFour' }"
      @click="$emit('clickGridNumber', 'gridFour', 4)"
    >
      <i class="mc-fa icon-fill_grid-4"></i>
    </span>
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridSix' }"
      @click="$emit('clickGridNumber', 'gridSix', 6)"
    >
      <i class="mc-fa icon-fill_grid-6"></i>
    </span>
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridEight' }"
      @click="$emit('clickGridNumber', 'gridEight', 8)"
    >
      <i class="mc-fa icon-fill_grid-8"></i>
    </span>
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridNine' }"
      @click="$emit('clickGridNumber', 'gridNine', 9)"
    >
      <i class="mc-fa icon-fill_grid-9"></i>
    </span>
    <span
      class="mc-trackvideo-content__view-button"
      :class="{ active: gridState == 'gridSixteen' }"
      @click="$emit('clickGridNumber', 'gridSixteen', 16)"
    >
      <i class="mc-fa icon-fill_grid-16"></i>
    </span>
    <span class="mc-trackvideo-content__view-button" @click="clickFullScreen()">
      <i class="mc-fa icon-fill_fullscreen"></i>
      <i class="mc-fa icon-fill_exit-fullscreen"></i>
    </span>
  </div>
</template>
